import * as React from 'react';
import { antGrey, appHomeCardsWidgetTitleStyle, runwayColors } from '@/components/styles/globalStyles';
import Text from 'antd/lib/typography/Text';
import Paragraph from 'antd/lib/typography/Paragraph';
import Button from 'antd/lib/button';
import { CopyOutlined, ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons';
import { globalMessage } from '@/utils/globalMessage';

export interface ReleaseSummaryWidgetProps {
    summaryMessage: string;
}

export const ReleaseSummaryWidget: React.FC<ReleaseSummaryWidgetProps> = ({ summaryMessage }) => {
    const copyToClipboard = async (key) => {
        try {
            await navigator.clipboard.writeText(key);
            globalMessage.success('Copied to clipboard!');
        } catch {
            // No-op
        }
    };

    const trimmedSummaryMessage = summaryMessage?.trim();

    const [isExpanded, setIsExpanded] = React.useState<boolean>(false);

    return (
        <div
            style={{
                borderColor: antGrey.grey5,
                borderWidth: 1,
                borderStyle: 'solid',
                padding: '12px 20px',
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
                borderRadius: 8,
                marginBottom: 28,
                position: 'relative',
                backgroundColor: runwayColors.white,
            }}
        >
            <div style={{ padding: 8, position: 'absolute', right: 0, top: 0, zIndex: 2, display: 'flex', gap: 0 }}>
                <Button
                    onClick={() => copyToClipboard(trimmedSummaryMessage)}
                    icon={<CopyOutlined style={{ color: antGrey.grey6 }} />}
                    type="link"
                    style={{ width: 28 }}
                />
                <Button
                    onClick={() => setIsExpanded(!isExpanded)}
                    style={{ width: 28 }}
                    icon={
                        isExpanded ?
                            <ZoomOutOutlined style={{ color: antGrey.grey6 }} />
                        :   <ZoomInOutlined style={{ color: antGrey.grey6 }} />
                    }
                    type="link"
                />
            </div>
            <Text style={{ ...appHomeCardsWidgetTitleStyle }}>Release summary</Text>
            {trimmedSummaryMessage && (
                <div
                    style={{
                        borderColor: antGrey.grey5,
                        borderWidth: 1,
                        borderStyle: 'solid',
                        padding: '12px 20px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 8,
                        borderRadius: 8,
                        marginBottom: 28,
                        backgroundColor: runwayColors.white,
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                        width: 'calc(100% + 2px)',
                        left: -1,
                        top: -1,
                        zIndex: 1,
                        position: 'absolute',
                        transition: 'all 0.2s ease-in-out',
                        ...(isExpanded ?
                            {
                                opacity: 1,
                            }
                        :   {
                                opacity: 0,
                                pointerEvents: 'none',
                            }),
                    }}
                >
                    <Text style={{ ...appHomeCardsWidgetTitleStyle }}>Release summary</Text>
                    <Paragraph
                        style={{
                            fontSize: 14,
                            color: antGrey.grey9,
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {trimmedSummaryMessage}
                    </Paragraph>
                </div>
            )}
            {trimmedSummaryMessage ?
                <Paragraph
                    style={{
                        fontSize: 14,
                        color: antGrey.grey8,
                        whiteSpace: 'pre-wrap',
                    }}
                    ellipsis={{ rows: 3, expandable: false }}
                >
                    {trimmedSummaryMessage}
                </Paragraph>
            :   <Text
                    style={{
                        fontSize: 14,
                        color: antGrey.grey6,
                    }}
                >
                    No release summary
                </Text>
            }
        </div>
    );
};
